// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcu_a bhn_ea bhn_ke bhn_ju bhn_sn bhn_wl"};